export type Radius = "0" | "2px" | "6px" | "10px" | "24px";

export type BorderRadiusType = {
    name: string;
    radius: Radius;
};

export const borderRadiusOptions: BorderRadiusType[] = [
    { name: "-", radius: "0" },
    { name: "S", radius: "2px" },
    { name: "M", radius: "6px" },
    { name: "L", radius: "10px" },
    { name: "XL", radius: "24px" },
];

export { default as BorderRadius } from "./BorderRadius.vue";
